<template>
  <v-container fluid>
    <v-row>
      <v-col sm="12" >
        <router-view/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import './index'
</script>
